/**
 * 请求拦截器，用于添加授权头。
 * */
import {comTag, RequestInterceptor} from "@/Fwk/Http/comRequest";
import {RSAHelper} from "@/Fwk/Encrypt/RSAHelper";
import {MD5Helper} from "@/Fwk/Encrypt/MD5Helper";
import Encrypt from "@/Fwk/Encrypt/Encrypt";
import Util from "@/Master/Util";
import LoginNetManager from "@/Core/Login/LoginNetManager";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import UtilGzip from "@/Master/UtilGzip";
import AESHelper from "@/Fwk/Encrypt/AESHelper";

export const AuthInterceptor: RequestInterceptor = async (config: any) => {

    //参数默认会带上token
    if (config.isToken){
        //检测所有接口增加上默认token
        if (LoginNetManager.Instance.getLoginToken){
            config.headers.Authorization = LoginNetManager.Instance.getLoginToken;
        }
        else{
            if (LoginUIManager.getLastUserToken){
                config.headers.Authorization = LoginUIManager.getLastUserToken;
            }
        }
    }

    if (Util.isLog) {
        console.log(comTag,'请求拦截器-加密前:',config.url,Util.DeepClone(config));
    }

    if (config.encryptionType == 'RSA') {
        const body = Util.DeepClone(config.body);
        const requestDataStr = JSON.stringify(body.request_data);

        //当前时间
        const strStamp = Util.localTimeStampMill;

        //动态生成16位的IV
        const iv = AESHelper.GenerateIV(16);

        // rsa加密 IV
        let aesData = AESHelper.EncryptWeb(requestDataStr, iv);

        // rsa加密 IV
        const rsaEncKey = RSAHelper.Encrypt(iv, RSAHelper.RSA_KEY);

        // 数据签名，按通讯协议
        const sign = MD5Helper.CreateMD5(`${Encrypt.SIGN_KEY}${aesData}${Encrypt.SIGN_KEY}${strStamp}${Encrypt.SIGN_KEY}`).toLowerCase();

        body.sign = sign;
        body.timestamp = strStamp;
        body.request_data = aesData;
        if (config.isGzip){
            const compressedData = UtilGzip.compress(aesData);
            config.body = compressedData;
        }else{
            body.request_data = aesData;
            config.body = JSON.stringify(body);
        }


        config.headers = {
            ...config.headers,
            'Content-Type': 'application/json',
            's-encode-v1': 's0523',
            's-encode-rsa': rsaEncKey,
            's-encode-sign': sign,
            's-encode-timestamp': strStamp,
            'sn-etag-hash': ``,
        };
        if (config.isGzip){
            config.headers['Content-Encoding'] = 'gzip';
        }

        if (Util.isLog) {
            console.log(comTag,'请求拦截器-加密后:', config.url,config);
        }
    } else {
        if (config.encryptionType != 'Binary') {
            config.body = JSON.stringify(config.body);
        }
    }
    return config;
};

